import styled from '@emotion/styled'

export const RevenueContainer = styled.div`
  margin-top: 1.25rem;
  display: flex;
  flex-wrap: wrap;

  & > div {
    flex-basis: calc(50% - 36px); /* -12px to account for widget borders and margins */
  }

  & > :nth-of-type(even) {
    margin-left: 20px;
  }

  & > :not(:nth-of-type(-n + 2)) {
    margin-top: 20px;
  }
`
